module.exports = __webpack_public_path__ + "img/Trophy.52197004.jpg";